import LBox from "@components/LBox";
import LText from "@components/LText";
import { isDebugMode, isDevEnv } from "@utils/envs";
import { FeatureFlags, useFeatureFlags } from "@utils/featureFlags";
import { Switch } from "react-native";

const featureFlagsToDisplay: FeatureFlags[] = [
  "AccessMarketplaceCreation",
  "PrebidPOC",
] as const;

export const SettingsFeatureFlags = () => {
  const { getFlagValue, setFlagValue } = useFeatureFlags();

  if (!isDebugMode() && !isDevEnv()) {
    return null;
  }

  return (
    <LBox paddingTop="s2">
      <LText variant="h2" paddingBottom="s1">
        ⛳ Feature Flags
      </LText>
      {featureFlagsToDisplay.map((featureName) => (
        <LBox
          key={featureName}
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          py="s1_5"
          borderBottomWidth={1}
          borderColor="greyBorder"
        >
          <LText paddingRight="s1">{featureName}:</LText>
          <Switch
            ios_backgroundColor="#3e3e3e"
            onValueChange={(newValue) => setFlagValue(featureName, newValue)}
            value={getFlagValue(featureName)}
          />
        </LBox>
      ))}
    </LBox>
  );
};
